import { TaasTable } from '@/components/TaasTable';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { FC } from 'react';

/**
 * Props for `ComparisonTable`.
 */
export type ComparisonTableProps =
  SliceComponentProps<Content.ComparisonTableSlice>;

/**
 * Component for "ComparisonTable" Slices.
 */
const ComparisonTable: FC<ComparisonTableProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={'relative text-white pt-24'}
      style={{
        backgroundImage: 'linear-gradient(to bottom, #0E1010, #0F423A)',
      }}
    >
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center gap-12">
        <TaasTable />
      </div>
    </section>
  );
};

export default ComparisonTable;
